<cookie-bar></cookie-bar>
<router-outlet></router-outlet>